import { Toaster } from '@ccp/ui';
import type { QueryClient } from '@tanstack/react-query';
import { QueryClientProvider } from '@tanstack/react-query';
import type { i18n as I18n } from 'i18next';
import type { ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { I18nextProvider } from 'react-i18next';
import { AppErrorState } from './error-state.js';

export interface ProvidersProps {
  readonly queryClient: QueryClient;
  readonly i18n: I18n;
  readonly children: ReactNode;
}

/**
 * Everything the whole application needs, in one place: server state, translations, toasts, and
 * the boundary that keeps a render failure from blanking the workspace mid-call.
 */
export function Providers({ queryClient, i18n, children }: ProvidersProps) {
  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <ErrorBoundary FallbackComponent={AppErrorState}>{children}</ErrorBoundary>
        <Toaster />
      </QueryClientProvider>
    </I18nextProvider>
  );
}
